/* ============================================================================
 * Project        : Deloitte Digital Compliance
 * File           : ProjectUser.jsx
 * Version        : 1.0.0
 * Author         : Team Neubinary
 * Created On     : 2026-06-24
 *
 * Description    : Digital Compliance for Automation and Governance
 *
 * Change History :
 * ----------------------------------------------------------------------------
 * Date         | Version | Author           | Description
 * ----------------------------------------------------------------------------
 * 2026-06-24   | 1.0.0   | Team Neubinary   | Initial creation
 * <YYYY-MM-DD> | x.x.x   | <Name/Team>      | <Change description>
 * ============================================================================
 *
 * Copyright (c) 2026 AU79 Consulting Services Pvt. Ltd.
 * All Rights Reserved.
 *
 * This source code and its contents are confidential and proprietary to
 * AU79 Consulting Services Pvt. Ltd. Unauthorized copying, reproduction,
 * modification, distribution, or disclosure of this material, in whole or
 * in part, is strictly prohibited without prior written permission from
 * AU79 Consulting Services Pvt. Ltd.
 * ============================================================================
 */
import { Box, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import CustomDataGridV2 from "../../../common/datagrid/CustomDataGridV2";
import { useDispatch, useSelector } from "react-redux";
import {
  dashboardAction,
  HandleApiActions,
} from "../../../../../redux/actions";
import { Link } from "react-router-dom";
import { componentStyle } from "../../../../../config/appTheme";

function ProjectUser() {
  // Hooks

  const dispatch = useDispatch();
  const selectedProject = useSelector(
    (state) => state?.projectConfigReducer?.selectedProjectDetails
  );

  // State
  const [statusDetails, setStatusDetails] = useState([]);
  const [recentActivitiesDetails, setRecentActivitiesDetails] = useState([]);

  // functions
  const getDefaultValue = (arr) => (arr && arr.length > 0 ? arr[0] : 0);

  const getStatusDetails = async (projectId) => {
    let apiDetails = dashboardAction.get_dash_board_status;
    delete apiDetails.action_type;

    const resp = await dispatch(
      HandleApiActions({
        ...apiDetails,
        params: {
          project_id: projectId,
        },
        show_toast: false,
      })
    );
    if (resp.error) {
      setStatusDetails([]);
    } else {
      setStatusDetails(resp.data);
    }
  };

  const getRecentActivitiesDetails = async (projectId) => {
    let apiDetails = dashboardAction.get_dash_board_activities;
    delete apiDetails.action_type;

    const resp = await dispatch(
      HandleApiActions({
        ...apiDetails,
        params: {
          project_id: projectId,
        },
        show_toast: false,
      })
    );
    if (resp.error) {
      setRecentActivitiesDetails({});
    } else {
      setRecentActivitiesDetails(resp.data);
    }
  };

  // const

  const project = getDefaultValue(statusDetails?.project_details);
  const variant = getDefaultValue(statusDetails?.variant_details);
  const swm = getDefaultValue(statusDetails?.swm_details);
  const ee = getDefaultValue(statusDetails?.ee_details);
  const vehicleSystem = getDefaultValue(statusDetails?.vehicle_system_details);
  const vehicleComponents = getDefaultValue(
    statusDetails?.vehicle_components_details
  );
  const selectedProjectId = selectedProject?.project_id;

  // useEffects

  useEffect(() => {
    if (selectedProject?.project_id) {
      getRecentActivitiesDetails(Number(selectedProject?.project_id));
      getStatusDetails(Number(selectedProject?.project_id));
    }
  }, [selectedProject]);

  const ROWS = [
    {
      id: 1,
      type: "Project",
      ownerCoOwner: project?.owners + project?.co_owners || 0,
      editorViewer: project?.editors + project?.viewers || 0,
      moduleType: 100,
    },
    {
      id: 3,
      type: "EE Component",
      ownerCoOwner: ee?.owners + ee?.co_owners || 0,
      editorViewer: ee?.editors + ee?.viewers || 0,
      moduleType: 300,
    },
    {
      id: 4,
      type: "Software Module",
      ownerCoOwner: swm?.owners + swm?.co_owners || 0,
      editorViewer: swm?.editors + swm?.viewers || 0,
      moduleType: 400,
    },
  ];
  const COLUMNS = [
    {
      field: "type",
      headerName: "Type",
      flex: 1,
    },
    {
      field: "ownerCoOwner",
      headerName: "Owners & Co-Owners",
      flex: 1,
      renderCell: (params) => {
        return (
          <Link
            to={`/dashboard/user-management?project_id=${selectedProjectId}&tab=project_management`}
            style={{ textDecoration: "none" }}
          >
            <Typography sx={{ fontSize: "12px" }}>{params.value}</Typography>
          </Link>
        );
      },
    },
    {
      field: "editorViewer",
      headerName: "Editors & Viewers",
      flex: 1,

      renderCell: (params) => {
        return (
          <Link
            to={`/dashboard/user-management?project_id=${selectedProjectId}&tab=project_management`}
            style={{ textDecoration: "none" }}
          >
            <Typography sx={{ fontSize: "12px" }}>{params.value}</Typography>
          </Link>
        );
      },
    },
  ];

  return (
    <Box>
      <Box sx={{ textAlign: "left" }}>
        <Typography sx={componentStyle.font.tabLevelHeader}>User</Typography>
      </Box>
      <CustomDataGridV2 columns={COLUMNS} rows={ROWS} />
    </Box>
  );
}

export default ProjectUser;
